import React, { FC, useCallback, useState, memo, useEffect, createContext } from 'react';
import { useDrop, useDrag } from 'react-dnd';
import { MenuOutlined, SettingOutlined, DeleteOutlined } from '@ant-design/icons';
import { RootState } from 'reducers';
import { connect } from 'react-redux';
import update from 'immutability-helper';


import { updatePageConfig, updateInsertPositionId, updateMoreState, updateModuleData, deleteModule, changePlatform } from '../platform/platform-edit.reducer'
import { modulesList } from 'model/decorate/decorate.model'
import { Tabs } from 'antd';

import { ImageCarouselSet } from './modules/image_carousel';
import { TitleTextSet } from './modules/title_text';
import { ConfigSet } from './modules/config';
import { ActiveGroupSet } from './modules/active-group';
import { ActiveSeckillSet } from './modules/active-seckill';
import { AuxiliaryBlankSet } from './modules/auxiliary_blank';
import { AuxiliaryLineSet } from './modules/auxiliary_line';
import { ClassificationListSet } from './modules/classification_list';
import { ColumnNavSet } from './modules/column-nav';
import { CouponScrollSet } from './modules/coupon-scroll';
import { CustomAreaSet } from './modules/custom_area';
import { GoodsCubeSet } from './modules/goods-cube';
import { GoodsScrollSet } from './modules/goods-scroll';
import { GoodsSet } from './modules/goods';
import { ImageAdSet } from './modules/image_ad';
import { ListNavSet } from './modules/list_nav';
import { NoticeSet } from './modules/notice';
import { PageTabSet } from './modules/page_tab';
import { RecommendationListSet } from './modules/recommendation_list';
import { ShopSet } from './modules/shop';
import { TabNavSet } from './modules/tab_nav';
import { SearchSet } from './modules/search';
import { PopupSet } from './modules/popup';
import { MainMeetingSet } from './modules/main_meeting';
import { TingmimiHotSet } from './modules/tingmimi_hot';
import { ImageCarouselFillSet } from './modules/image_carousel_fill';
import { GoodsCubeFillSet } from './modules/goods-cube-fill';
import { ImageAreaSet } from './modules/image_area';
import LinkSelection from './link-selection'
import ProductSelection from './product-selection'
import { FloatingFrameSet } from './modules/floating-frame';
import { CollageListNavSet } from './modules/collage_list_nav';
const { TabPane } = Tabs;
interface ModulesSettingProps extends StateProps, DispatchProps { }

interface ModuleItemProps {
  onDrop: (item: any) => void
  id: string
  module?: any
  insertPositionId: string
  updatePageConfigPrivate: () => void
  findModulePrivate: (id: string) => { module: any, index: number }
  moveModulePrivate: (dragId: string, index: number) => void
  moveAtIndex?: number
  updateInsertPositionId: (id: string) => void
  updateMoreState: (props: { [key: string]: any }) => void
  settingModuleId?: string
  moduleData: any
  deleteModule?: any
  language: string
  platform: string
}
interface DropResult {
  name: string
}

const onDrop = (moduleData: any, dragInfo: any) => {
}
const getModuleName = (type: string) => {
  const moduleData = modulesList.filter((v: any) => `${v.type}` === type)[0]
  if (moduleData) {
    return moduleData.title
  }
}
const ModuleItem: FC<ModuleItemProps> = (({ moduleData, onDrop, id, updatePageConfigPrivate, findModulePrivate, moveModulePrivate, moveAtIndex, updateMoreState, settingModuleId, deleteModule, language, platform }) => {
  const expand = false;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ['all'],
    drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    canDrop: () => false,
    hover(props) {
      //组件位置调整
      if (props.id && props.id !== id) {
        const { index } = findModulePrivate(id);
        moveModulePrivate(props.id, index)
      }

    },
  }, [onDrop, id, findModulePrivate, moveModulePrivate])

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'all',
    item: { id },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult<DropResult>()
      if (item && dropResult && moveAtIndex !== -1) {
        updatePageConfigPrivate()
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      handlerId: monitor.getHandlerId(),
    }),
  }), [id, moveAtIndex, moveModulePrivate])
  return <div className={`module-item ${settingModuleId === id && 'selected'} ${isDragging && 'dragging'} ${expand && 'expand'}`} >
    <div className={`module-header  `} ref={(node) => drag(drop(node))}>
      <MenuOutlined className="icon" />
      <p className="title text-1">{getModuleName(moduleData.type)}</p>
      <div className="arrow-con">
        {/* <UpOutlined className="arrow" /> */}
        <SettingOutlined className="arrow" onClick={
          () => {
            updateMoreState({
              settingModuleId: id
            })
          }
        } />
        <DeleteOutlined className="delete" onClick={
          () => {
            updateMoreState({
              settingModuleId: id + 'delete'
            });
            deleteModule(id)
          }
        } />
      </div>

    </div>
    {/* <div className="module-content">
            {module}
        </div> */}
  </div>
})

/**获取模块设置模块
 * @param module 模块信息
 * @param methods 操作方法
 * @param selectedInfo 选中的链接/商品信息
 * 
 * 
*/
const getModuleSetModule = (module: { type: string, id: string, dataField: any }, methods: any, selectedInfo: any, otherInfo: any) => {
  switch (module.type) {
    case 'image_carousel':
      return <ImageCarouselSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'image_carousel_fill':
      return <ImageCarouselFillSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'title_text':
      return <TitleTextSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'active-group':
      return <ActiveGroupSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'active-seckill':
      return <ActiveSeckillSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'auxiliary_blank':
      return <AuxiliaryBlankSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'auxiliary_line':
      return <AuxiliaryLineSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'classification_list':
      return <ClassificationListSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'column-nav':
      return <ColumnNavSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'coupon-scroll':
      return <CouponScrollSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'custom_area':
      return <CustomAreaSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'goods-cube':
      return <GoodsCubeSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'goods-cube-fill':
      return <GoodsCubeFillSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'goods-scroll':
      return <GoodsScrollSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'goods':
      return <GoodsSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'image_ad':
      return <ImageAdSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'list_nav':
      return <ListNavSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'collage_list_nav':
      return <CollageListNavSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'notice':
      return <NoticeSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'page_tab':
      return <PageTabSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'recommendation_list':
      return <RecommendationListSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'shop':
      return <ShopSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'tab_nav':
      return <TabNavSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'search':
      return <SearchSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'popup':
      return <PopupSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'floating_frame':
      return <FloatingFrameSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'main_meeting':
      return <MainMeetingSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'tingmimi_hot':
      return <TingmimiHotSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    case 'image_area':
      return <ImageAreaSet otherInfo={otherInfo} dataField={module.dataField} id={module.id} key={module.id} methods={methods} selectedInfo={selectedInfo} />
    default:
      return <div className="none">请选择模块</div>
  }
}

export const SkytoneCardContext = createContext<{ SkytoneCard?: boolean }>({ SkytoneCard: false });
const ModulesSetting: FC<ModulesSettingProps> = memo(({ pageData, pageConfig, insertPositionId, updatePageConfig, updateInsertPositionId, updateMoreState, settingModuleId, updateModuleData, deleteModule, language, platform }) => {
  const [pageConfigPrivate, setPageConfigPrivate] = useState(pageConfig);
  const [moveAtIndex, setMoveMoveAtIndex] = useState(-1)
  const [tabActive, setTabActive] = useState('3')
  const [settingModule, setSettingModule] = useState(<div></div>);
  const [showLinkSelection, setShowLinkSelection] = useState(false)
  const [showProductSelection, setShowProductSelection] = useState(false)
  const [selectedInfo, setSelectedInfo] = useState({})//选中的信息详情

  const findModulePrivate = useCallback(
    (id: string) => {
      const module = pageConfigPrivate.filter((c: any) => `${c.id}` === id)[0]
      return {
        module,
        index: pageConfigPrivate.indexOf(module)
      }
    },
    [pageConfigPrivate],
  )
  const moveModulePrivate = useCallback(
    (dropId: string, index: number) => {
      const { module, index: originIndex } = findModulePrivate(dropId)
      setMoveMoveAtIndex(index)
      // console.log('index',index,'originIndex',originIndex)
      setPageConfigPrivate(
        update(pageConfigPrivate, {
          $splice: [
            [originIndex, 1,],
            [index, 0, module]
          ]
        })
      )
    },
    [pageConfigPrivate, findModulePrivate, setMoveMoveAtIndex, setPageConfigPrivate]
  )
  const updatePageConfigPrivate = useCallback(() => {
    updatePageConfig(pageConfigPrivate)
  }, [pageConfigPrivate, updatePageConfig])

  const setShowLinkSelectionPrivate = useCallback(
    (show: boolean, returnData: any) => {
      // console.log('returnData',returnData)/
      setSelectedInfo(returnData);
      setTimeout(() => {
        setSelectedInfo({});
      }, 1000)
      setShowLinkSelection(show)
    }
    , [setShowLinkSelection])
  const setShowProductSelectionPrivate = useCallback(
    (show: boolean, returnData: any) => {
      setSelectedInfo(returnData);
      setShowProductSelection(show)
      setTimeout(() => {
        setSelectedInfo({});
      }, 1000)

    }
    , [setShowProductSelection])

  useEffect(() => {
    setPageConfigPrivate(pageConfig);
  }, [pageConfig])

  useEffect(() => {
    const { module } = findModulePrivate(settingModuleId), methods = {
      updateModuleData,
      setShowLinkSelectionPrivate,
      setShowProductSelectionPrivate,
      updateMoreState
    };
    let otherInfo = {
      settingModuleId,
      language
    }
    if (module) {
      const SkytoneCard = pageConfig.concat().filter((e: any) => e.type === 'config')[0]?.dataField?.SkytoneCard;
      setSettingModule(getModuleSetModule(
        {
          ...module,
          dataField: {
            ...module.dataField,
            SkytoneCard,
          }
        },
        methods, selectedInfo, otherInfo)
      )
    } else {
      
      const configModule = pageConfigPrivate?.filter((v: any) => {
        return `${v.type}` === 'config'
      })[0];
      configModule && setSettingModule(
        <ConfigSet language={language} platform={platform} otherInfo={otherInfo} dataField={configModule.dataField} pageData={pageData} pageConfig={pageConfigPrivate} methods={methods} selectedInfo={selectedInfo} id={configModule.id} />
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setSettingModule, settingModuleId, pageConfigPrivate, findModulePrivate, updateModuleData, setShowLinkSelectionPrivate, selectedInfo])
  useEffect(() => {
    const moduleIdArr = settingModuleId ? settingModuleId.split('delete') : [];
    moduleIdArr.length > 1 ? setTabActive('1') : (moduleIdArr[0] === 'none' ? setTabActive('1') : setTabActive('2'));
  }, [settingModuleId])
  const [, drop] = useDrop(() => ({ accept: 'all' }))
  return <div className="modules-setting" ref={drop}>
    <Tabs activeKey={tabActive} className="custom-tabs" onChange={(e) => {
      setTabActive(e);
      const { module } = findModulePrivate(settingModuleId);
      const methods = {
        updateModuleData,
        setShowLinkSelectionPrivate,
        setShowProductSelectionPrivate,
        updateMoreState
      };
      let otherInfo = {
        settingModuleId,
        language
      };
      if(e === '3'){
        const configModule = pageConfigPrivate?.filter((v: any) => {
          return `${v.type}` === 'config'
        })[0]
        console.log(configModule)
        console.log('+++++++++++++++++')
        configModule && setSettingModule(
          <ConfigSet language={language} platform={platform} otherInfo={otherInfo} dataField={configModule.dataField} pageData={pageData} pageConfig={pageConfigPrivate} methods={methods} selectedInfo={selectedInfo} id={configModule.id} />
        )
      }else if(e === '2'){
        const SkytoneCard = pageConfig.concat().filter((e: any) => e.type === 'config')[0]?.dataField?.SkytoneCard;
        setSettingModule(getModuleSetModule(
          {
            ...module,
            dataField: {
              ...module?.dataField,
              SkytoneCard,
            }
          },
          methods, selectedInfo, otherInfo)
        );
      }
    }}>
      <TabPane tab="模块列表" key="1">
        {pageConfigPrivate?.map((v: any, i: number) => {
          return v.type !== 'config' && <ModuleItem
            moveAtIndex={moveAtIndex}
            updateInsertPositionId={updateInsertPositionId}
            findModulePrivate={findModulePrivate}
            moveModulePrivate={moveModulePrivate}
            insertPositionId={insertPositionId}
            key={v.id}
            updatePageConfigPrivate={updatePageConfigPrivate}
            updateMoreState={updateMoreState}
            id={v.id}
            moduleData={v}
            deleteModule={deleteModule}
            onDrop={(item) => onDrop(v, item)}
            settingModuleId={settingModuleId}
            language={language}
            platform={platform}
          />
        })}
      </TabPane>
      <TabPane tab="模块设置" key="2">
        {tabActive === '2' && settingModule}
      </TabPane>
      <TabPane tab="页面设置" key="3">
        {tabActive === '3' && settingModule}
      </TabPane>

    </Tabs>

    <LinkSelection language={language} show={showLinkSelection} setShowLinkSelectionPrivate={setShowLinkSelectionPrivate} />
    <SkytoneCardContext.Provider value={{ SkytoneCard: (pageConfig && pageConfig.concat().filter((e: any) => e.type === 'config')[0]?.dataField?.SkytoneCard) || false }}>
      <ProductSelection language={language} show={showProductSelection} setShowProductSelectionPrivate={setShowProductSelectionPrivate} />
    </SkytoneCardContext.Provider>
  </div>
})
const mapStateToProps = ({ decorateEdit }: RootState) => ({
  pageConfig: decorateEdit.pageConfig,
  pageData: decorateEdit.pageData,
  language: decorateEdit.language,
  platform: decorateEdit.platform,
  insertPositionId: decorateEdit.insertPositionId,
  settingModuleId: decorateEdit.settingModuleId,
});
const mapDispatchToProps = {
  updatePageConfig,
  updateMoreState,
  updateInsertPositionId,
  updateModuleData,
  deleteModule,
  changePlatform
}
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(mapStateToProps, mapDispatchToProps)(ModulesSetting);
